import { MarkElementMask } from './MarkElementMask';
import { isset } from '@Engage.Core';
export class TrimByLength extends MarkElementMask {
    trim(element) {
        this.removeMarkClass(element);
        if (isset(this.maskingOptions.AllowedCharactersCount) && this.maskingOptions.AllowedCharactersCount == 0) {
            this.removeAllText(element);
            this.addTerminator(element, "");
            return;
        }
        this.markExcluded(element);
        const result = this.splitElement(element);
        this.removeNotMarked(result.updatedElement);
        this.lastTrimElement = result.lastTrimElement;
    }
    fade(element) {
        this.removeMarkClass(element);
        this.markExcluded(element);
        const result = this.splitElementFade(element);
        this.removeNotMarkedFade(result.updatedElement);
    }
    getLastTrimElement() {
        return this.lastTrimElement;
    }
    unMask() {
        super.unMask();
        this.removeHeightFromContent();
    }
}
